/**
 * 全局Mixin
 */
export default {
  data() {
    return {};
  },
  methods: {
    // 全局方法
    msgCallback(from_id, send_id, msg_type) {
      this.sendMessage({
        type: "msgcallback",
        from_id,
        send_id,
        msg_type: "msg",
      });
    },
  },
};
